<template>
	<PopUp
		title="Legitimierung"
		size="lg"
		hide-cancel
		ok-text="Bestätigen"
		:ok-disabled="!dataValid"
		@ok="upload"
		@hidden="$emit('hidden')"
	>
		<Upload
			v-model="identification"
			:meta="meta"
			@input="identificationChanged"
		/>
	</PopUp>
</template>

<script>
import PopUp from "@/vue/common/PopUp";
import Upload from "./Upload";
import {isDefined} from "@/helper/Value";

export default {

	props: {
		meta: {
			type: Object,
			required: true,
		},
	},

	components: {
		PopUp,
		Upload,
	},

	data ()
	{
		return {
			identification: null,
		};
	},

	computed: {
		dataValid ()
		{
			return isDefined(this.identification);
		}
	},

	methods: {
		async upload()
		{
			if (!this.dataValid)
			{
				return;
			}

			this.$emit('ok', this.identification);
		},
		identificationChanged (identification)
		{
			if (identification && identification.async)
			{
				this.$emit('asyncFinish', identification);
			}
		},
	}
}
</script>